import db, { getContentRecommendationDb } from '../database/db';

const getDbInstance = () => db || getContentRecommendationDb() || null;

const fetchAndStoreCRData = async (data, customerId, isFullSync = true, pageUrl = '') => {
  try {
    const dbInstance = getDbInstance();
    if (!dbInstance) {
      return [];
    }

    const startTime = typeof performance !== 'undefined' ? performance.now() : null;
    let finalData = data;
    const customerStore = await dbInstance.createCustomerStore(customerId);
    if (!customerStore) {
      return [];
    }

    if (!isFullSync) {
      const pageUrlData = data?.filter((item) => item.finalurl === pageUrl);
      const existingRecords = await customerStore.toArray();
      const filteredData = existingRecords?.filter(
        (item) => item?.finalurl?.toLowerCase() !== pageUrlData?.[0]?.finalurl?.toLowerCase()
      );
      finalData = [...(filteredData || []), ...(pageUrlData || [])];
    }

    await dbInstance.transaction('rw', customerStore, async () => {
      await customerStore.clear();
      await insertDataInBatches(finalData, customerStore, 5000); // 5000 is the maxBatchSize
    });

    if (startTime !== null && typeof performance !== 'undefined') {
      const endTime = performance.now();
      const duration = (endTime - startTime) / 1000;
      console.log('endTime Indexed DB', duration);
    }

    return finalData;
  } catch (error) {
    console.error('Error fetching and storing data:', error);
    return [];
  }
};

const insertDataInBatches = async (data, customerStore, batchSize) => {
  if (!customerStore) {
    return;
  }

  for (let i = 0; i < data.length; i += batchSize) {
    const batch = data.slice(i, i + batchSize);
    await customerStore.bulkPut(batch);
  }
};

export default fetchAndStoreCRData;
